"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ActionModal", {
  enumerable: true,
  get: function get() {
    return _ActionModal["default"];
  }
});
exports["default"] = void 0;
var _Modal = _interopRequireDefault(require("./Modal"));
var _ActionModal = _interopRequireDefault(require("./ActionModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = _Modal["default"];